export default "__VITE_ASSET__MXCSnRKJ__"